import React, {useEffect, useState} from 'react';
import Header from "../Header";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Footer from "../Footer";
import {NavLink} from "react-router-dom";
import {sendRequestNasos, sendRequestQuduq} from "../../api/request";
import Loader from "../Loader";
import ModalFilter from "./ModalFilter";
import {ExcelPrint} from "../../units/Print";

const Monitoring = () => {
    const dateNow = new Date()
    const year = dateNow.getFullYear()
    let month = dateNow.getMonth() + 1
    let day = dateNow.getDate()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    const today = `${day}.${month}.${year}`

    const [currentRadioValue, setCurrentRadioValue] = useState(1)
    const [checkedTib, setCheckedTib] = useState(true);
    const [checkedPud, setCheckedPud] = useState(true);
    const [loading, setLoading] = useState(false)
    const [loadVil, setLoadVil] = useState(false)
    const [loadTib, setLoadTib] = useState(false)
    const [loadPud, setLoadPud] = useState(false)
    const [vilNomi, setVilNomi] = useState([])
    const [tib, setTib] = useState([])
    const [pudratchi, setPudratchi] = useState([])
    const [obekt, setObekt] = useState([])
    const [tibID, setTibID] = useState([])
    const [pudName, setPudName] = useState([])
    const [statistika, setStatistika] = useState([])
    const [stId, setStId] = useState()

    const handleVilChange = (e) => {
        setTib([])
        setTibID([])
        setPudName([])
        setPudratchi([])
        setLoading(false)
        setLoadTib(false)
        setLoadPud(false)
        setCheckedTib(true)
        setCheckedPud(true)
        setCurrentRadioValue(e.target.value);
        const getDataWithFilter = async () => {
            try {
                await sendRequestNasos({
                    url: "monitoring?vilID=" + e.target.value,
                    method: "GET",
                }).then((res) => {
                    if (res) {
                        setLoading(true)
                        setLoadTib(true)
                        setLoadPud(true)
                    }
                    setVilNomi(res.data.viloyat)
                    setTib(res.data.balansTash)
                    setPudratchi(res.data.pudratchi)
                    setObekt(res.data.obekt)
                    setStatistika(res.data.statistika)
                });
            } catch (e) {
                console.log(e)
            }
        }
        getDataWithFilter()
    }

    useEffect(() => {
        const GetVilNomi = async () => {
            try {
                await sendRequestNasos({
                    url: "monitoring",
                    method: "GET",
                }).then((res) => {
                    if (res) {
                        setLoadVil(true)
                        setLoading(true)
                        setLoadTib(true)
                        setLoadPud(true)
                    }
                    setVilNomi(res.data.viloyat)
                    setTib(res.data.balansTash)
                    setPudratchi(res.data.pudratchi)
                    setObekt(res.data.obekt)
                    setStatistika(res.data.statistika)
                });
            } catch (e) {
                console.log(e)
            }
        }
        GetVilNomi()
    }, []);

    const handleTibChange = (e) => {
        setPudName([])
        setLoading(false)
        setLoadPud(false)
        setCheckedPud(true)
        if (!tibID.includes(e.target.value)) {
            tibID.push(e.target.value)
        } else {
            if (tibID.indexOf(e.target.value) > -1) {
                tibID.splice(tibID.indexOf(e.target.value), 1)
            }
        }
        const getDataWithFilterTib = async () => {
            try {
                await sendRequestNasos({
                    url: "monitoring-tib?vilID=" + currentRadioValue + "&tibID=" + tibID,
                    method: "GET",
                }).then((res) => {
                    if (res) {
                        setLoading(true)
                        setLoadPud(true)
                    }
                    setVilNomi(res.data.viloyat)
                    setTib(res.data.balansTash)
                    setPudratchi(res.data.pudratchi)
                    setObekt(res.data.obekt)
                    setStatistika(res.data.statistika)
                });
            } catch (e) {
                console.log(e)
            }
        }
        getDataWithFilterTib()
    }

    const handlePudChange = (e) => {
        setLoading(false)
        if (!pudName.includes(e.target.value.toString())) {
            pudName.push(e.target.value)
            // setPudName(e.target.value)
        } else {
            if (pudName.indexOf(e.target.value) > -1) {
                pudName.splice(pudName.indexOf(e.target.value), 1)
            }
        }
        const getDataWithFilterPud = async () => {
            try {
                await sendRequestNasos({
                    url: "monitoring-tib-pud?vilID=" + currentRadioValue + "&tibID=" + tibID + "&pudName=" + pudName,
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setVilNomi(res.data.viloyat)
                    setTib(res.data.balansTash)
                    setPudratchi(res.data.pudratchi)
                    setObekt(res.data.obekt)
                    setStatistika(res.data.statistika)
                });
            } catch (e) {
                console.log(e)
            }
        }
        getDataWithFilterPud()
    }

    return (
        <>
            <Header />
            <div className="container _container-large">
                <div className="mt-4 mt-sm-5 _container-large">
                    <div className="card py-3 mb-0" style={{backgroundColor: "#cfe2ff"}}>
                        <h3 className="text-center" style={{maxWidth: "1000px", marginLeft: "auto", marginRight: "auto"}}>2021-2025-yillarda o‘rnatilgan "Nasos" qurilmalari to‘g‘risida ma'lumot</h3>
                    </div>
                    <div className="row mt-4 mt-sm-4">
                        <div className="col-md-12 col-lg-8">
                            <div className="card d-block p-2 mb-3">
                                <button className=" mt-2 mt-sm-0 btn btn-outline-primary py-0 ms-2 active"><FontAwesomeIcon icon="fa-regular fa-calendar" /> 21-25</button>
                                <NavLink to="/nasos" className="mt-2 mt-sm-0 btn btn-warning py-0 ms-2"><FontAwesomeIcon icon="fa-solid fa-list-ol" /> Hisobot</NavLink>
                                <NavLink to="/nasos/nasos-jadval" className="mt-2 mt-sm-0 btn btn-info py-0 ms-2"><FontAwesomeIcon icon="fa-solid fa-check-double" /> Barchasi</NavLink>
                                <button
                                    onClick={()=>ExcelPrint("Data ("+today+")", "nasos","tblData")}
                                    className=" mt-2 mt-sm-0 btn btn-success py-0 ms-2">
                                    <FontAwesomeIcon icon="fa-solid fa-file-excel" /> Excel
                                </button>
                            </div>
                            <div className="table-responsive" style={{maxHeight: "1200px"}}>
                                <table data-cols-width="5,7,50,18,17,30,17,30,19,6,17,15" className="table table-bordered table-hover text-center table-style-all" style={{fontSize: "13px"}} id="tblData">
                                    <thead className="table-primary align-middle sticky-top" style={{lineHeight: "15px", top: "-1px"}}>
                                    <tr data-height="20">
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">T/r</th>
                                        <th className="d-none" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">St/Id</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">Obekt nomi</th>
                                        <th className="d-none" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">Viloyat</th>
                                        <th className="d-none" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">Tuman</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">Balans tashkilot</th>
                                        <th className="d-none" data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">KOD/IMEI</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">Pudratchi</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">Integratsiya vaqti</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" rowSpan={2} scope="col">DXSH</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" colSpan={2} scope="col">Oxirgi kelgan ma'lumot</th>
                                    </tr>
                                    <tr data-height="20">
                                        {/*<th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Sath (sm)</th>*/}
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">Chiqqan suv (m<sup>3</sup>)</th>
                                        <th data-fill-color="cfe2ff" data-b-a-s="thin" data-a-h="center" data-a-v="middle" data-f-bold="true" scope="col">O'lchagan vaqti</th>
                                    </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                    {
                                        loading ?
                                            obekt?.map((item, index) => {
                                                return (
                                                    <tr key={index} >
                                                        <th data-t="n" data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-bold="true" scope="row">{index+1}</th>
                                                        <th className="d-none" data-t="n" data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-bold="true" scope="row">{item.id}</th>
                                                        <td
                                                            data-b-a-s="thin" data-a-v="middle" data-f-bold="true"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#staticBackdrop"
                                                            onClick={() => setStId(item.id)}
                                                            className="text-start"
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            {item.obekt}
                                                        </td>
                                                        <td className="d-none text-nowrap" data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.vil_nomi}</td>
                                                        <td className="d-none text-nowrap" data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.tum_nomi}</td>
                                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" className="text-nowrap">{item.name}</td>
                                                        {
                                                            typeof item.code == "string" ?
                                                                <td className="d-none" data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.code}</td>
                                                                : <td className="d-none" data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n" data-num-fmt="0">{item.code}</td>
                                                        }
                                                        {/*<td className="d-none text-nowrap" data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n">{item.code}</td>*/}
                                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" className="text-nowrap">{item.company}</td>
                                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" className="text-nowrap">{item.created_at}</td>
                                                        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-f-bold="true" className="text-nowrap">{item.dxsh}</td>
                                                        {/*{*/}
                                                        {/*    item.level ?*/}
                                                        {/*        <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n">{item.level}</td>*/}
                                                        {/*        : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.level}</td>*/}
                                                        {/*}*/}
                                                        {
                                                            item.volume ?
                                                                <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n">{item.volume}</td>
                                                                : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.volume}</td>
                                                        }
                                                        {
                                                            item.sana ?
                                                                <td data-b-a-s="thin" data-a-v="middle" data-a-h="center" data-t="n" data-num-fmt="0">{item.sana}</td>
                                                                : <td data-b-a-s="thin" data-a-v="middle" data-a-h="center">{item.sana}</td>
                                                        }
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={8}><Loader /></td></tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <div className="card mt-3 mt-lg-0">
                                <div className="card-header " style={{backgroundColor: "#cfe2ff"}}>
                                    <p className="text-center m-0"><strong>Boshqarmalar kesimida</strong></p>
                                </div>
                                <div className="d-flex justify-content-between p-1">
                                    <div className="list-group" style={{flexBasis: "35%"}}>
                                        <table className="table table-bordered table-hover m-0 text-center">
                                            <tbody>
                                            {
                                                loadVil ?
                                                    vilNomi.map((item, index) => {
                                                        return(
                                                            <tr key={index}>
                                                                <td className="text-start">
                                                                    <label key={index}>
                                                                        <input
                                                                            onChange={handleVilChange}
                                                                            checked={currentRadioValue == item.id}
                                                                            className="form-check-input me-2"
                                                                            name="flexRadioDefault"
                                                                            value={item.id} type="radio"
                                                                        />
                                                                        {item.vil_nomi}
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    : <Loader />
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="list-group list-pud-bar" style={{flexBasis: "64%", borderRadius: "0", maxHeight: "435px"}}>
                                        <table className="table table-bordered table-hover m-0 text-center" style={{fontSize: "14px"}}>
                                            <tbody>
                                            {
                                                loadTib ?
                                                    tib.map((item, index) => {
                                                        return(
                                                            <tr key={index}>
                                                                <td className="text-start">
                                                                    <label key={index}>
                                                                        <input
                                                                            defaultChecked={checkedTib}
                                                                            onChange={(e) => (setCheckedTib((state) => !state), handleTibChange(e))}
                                                                            className="form-check-input me-2"
                                                                            value={item.balans_tash} type="checkbox"
                                                                        />
                                                                        {item.name}
                                                                    </label>
                                                                </td>
                                                                <td style={{width: "50px"}}>{item.int_soni}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    : <Loader />
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card mt-4">
                                <div className="card-header " style={{backgroundColor: "#cfe2ff"}}>
                                    <p className="text-center m-0"><strong>Nasos qurulmalarini o'rnatgan pudratchilar</strong></p>
                                </div>
                                <ul className="list-group list-group-flush list-pud-bar">
                                    <li className="list-group-item p-1">
                                        <table className="table table-bordered table-hover m-0 text-center">
                                            <tbody>
                                            {
                                                loadPud ?
                                                    pudratchi.map((item, index) => {
                                                        return(
                                                            <tr key={index}>
                                                                <th style={{width: "30px"}} scope="row">{index+1}</th>
                                                                <td className="text-start">
                                                                    <label key={index}>
                                                                        <input
                                                                            defaultChecked={checkedPud}
                                                                            onChange={(e) => (setCheckedPud((state) => !state), handlePudChange(e))}
                                                                            className="form-check-input me-2"
                                                                            value={item.company} type="checkbox"
                                                                        />
                                                                        {item.company}
                                                                    </label>
                                                                </td>
                                                                <td style={{width: "50px"}}>{item.soni}</td>
                                                            </tr>
                                                        )
                                                    }) : <Loader />
                                            }
                                            </tbody>
                                        </table>
                                    </li>
                                </ul>
                            </div>
                            <div className="card mt-4" >
                                <div className="card-header" style={{backgroundColor: "#cfe2ff"}}>
                                    <p className="text-center m-0"><strong>Hosil bo'lgan jadval bo'yicha</strong></p>
                                </div>
                                <div className="card-body">
                                    <h5 className="card-title">Tahlil yurutilishi</h5>
                                    <p className="card-text text-danger">2 kun ichida 1 marta bo'lsa ham ma'lumot kelgan bo'lsa, ma'lumot yuborgan, aks holda uzulish bo'lgan hisoblanadi!</p>
                                    <table className="table table-bordered table-hover m-0 text-center">
                                        <thead>
                                        <tr>
                                            <th>Ma'lumot yuborgan <FontAwesomeIcon color="green" icon="fa-regular fa-circle-check" /></th>
                                            <th>Uzulish bo'lgan <FontAwesomeIcon color="#f0ad4e" icon="fa-solid fa-triangle-exclamation" /></th>
                                            <th>Umuman kelmagan <FontAwesomeIcon color="red" icon="fa-regular fa-circle-xmark" /></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            loading ?
                                                <>
                                                    <tr>
                                                        <td>{statistika[1]}</td>
                                                        <td>{statistika[2]}</td>
                                                        <td>{statistika[3]}</td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Jami: {statistika[0]}</th>
                                                    </tr>
                                                </>
                                            :  <tr><td colSpan={3}><Loader /></td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalFilter stId={stId} />
            <Footer />
        </>
    );
};

export default Monitoring;